import React from "react";
import PropTypes from "prop-types";
import classNames from "../../../utils/classNames";
import LockIcon from "../../atoms/icons/LockIcon";

export default function ChannelListItem({
    channel,
    isActive,
    unreadCount = 0,
    onClick,
    className,
}) {
    const channelName = channel.slug || channel.name;
    return (
        <li>
            <button
                type="button"
                className={classNames("band-sidebar__channel", className, {
                    "band-sidebar__channel--unread": unreadCount > 0,
                    "is-active": isActive,
                })}
                onClick={onClick}
                aria-label={`${unreadCount > 0 ? 'Unread channel' : 'Channel'} ${channel.name}${unreadCount ? `, ${unreadCount} unread` : ""}`}
            >
                <span className="band-sidebar__hash" aria-hidden="true">
                    {channel.privateChannel ? (
                        <LockIcon width={14} height={14} />
                    ) : (
                        '#'
                    )}
                </span>
                <span className="band-sidebar__channel-name">{channelName}</span>
                {unreadCount > 0 && (
                    <span className="band-sidebar__badge" aria-hidden="true">{unreadCount}</span>
                )}
            </button>
        </li>
    );
}

ChannelListItem.propTypes = {
    channel: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        name: PropTypes.string.isRequired,
        slug: PropTypes.string,
        privateChannel: PropTypes.bool,
    }).isRequired,
    isActive: PropTypes.bool,
    unreadCount: PropTypes.number,
    onClick: PropTypes.func,
    className: PropTypes.string,
};


